(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-wallpapers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tb-wallpapers__download').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      var url = button.getAttribute('href');
      var filename = button.getAttribute('download') || 'wallpaper.jpg';

      if (!url) return;

      button.classList.add('is-busy');

      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('Download failed');
          return response.blob();
        })
        .then(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = objectUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(objectUrl);
        })
        .catch(function () {
          window.location.href = url;
        })
        .finally(function () {
          button.classList.remove('is-busy');
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
